import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styles from './StudentsNavSquare.module.scss';

export default class StudentsNavSquare extends Component {
  render() {
    const { name, fontName, slug, activeFont, isSelected } = this.props;
    const firstName = name.split(' ')[0];
    const squareStlye = isSelected ? styles.selectedSquare : styles.square;

    return (
      <Link to={slug} className={squareStlye}>
        <div className={styles.fontSample} style={{ fontFamily: activeFont }}>Ag</div>
        <div className={styles.fontName}>{fontName}</div>
        <div className={styles.name}>{firstName}</div>
      </Link>
    );
  }
};

StudentsNavSquare.propTypes = {
  name: PropTypes.string,
  fontName: PropTypes.string,
  slug: PropTypes.string,
  activeFont: PropTypes.string,
  isSelected: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/StudentsNavSquare/StudentsNavSquare.jsx